import React from 'react';
import content from '../content';


export default function Work() {
  
  return (
    <div
      className="min-h-screen flex justify-center items-center flex-col"
      style={{
        background: '#FEFEFE',
      }}
      id="mywork"
    >
      <h1 className="text-indigo-900 text-5xl font-dosis font-bold xl:mt-12 md:mt-12">{content.work.title}</h1>
      {/* <p className="text-gray-600 text-2xl font-dosis ">I have done</p> */}
      <div className="flex flex-col md:flex-row justify-between items-center w-11/12">
        
      <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5 md:mb-12">
          {/* Card 1 */}
          <div className="rounded overflow-hidden shadow-lg">
          <img className="w-full" src="/assets/proyecto1_650.png" alt="proyecto1" />
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2">Cotizador de criptomonedas</div>
              <p className="text-gray-700 text-base">
                Aplicación web que permite conocer la cotización de una criptomoneda al instante.
              </p>
            </div>
            <div className="px-6 pt-4 pb-2">
            <a href="https://github.com/alan-boronat/spa-criptomonedas" target="_blank" rel="noopener noreferrer"> <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">GITHUB</button> </a> 
              <a href="https://app-criptomonedas.netlify.app" target="_blank" rel="noopener noreferrer"> <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">VER DEMO</button> </a>
            </div>
          </div>
          {/* Card 2 */}
          <div className="rounded overflow-hidden shadow-lg">
            <img className="w-full" src="/assets/proyecto2_650.png" alt="proyecto2"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2">Buscador de imágenes</div>
              <p className="text-gray-700 text-base">
              Aplicación web para buscar y descargar imágenes de cualquier tipo en alta resolución.
              </p>
            </div>
            <div className="px-6 pt-4 pb-2">
            <a href="https://github.com/alan-boronat/search-img" target="_blank" rel="noopener noreferrer"> <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">GITHUB</button> </a>
            <a href="https://react-buscar-img.netlify.app" target="_blank" rel="noopener noreferrer"> <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">VER DEMO</button> </a>
            </div>
          </div>

          {/* Card 3 */}
          <div className="rounded overflow-hidden shadow-lg">
          <img className="w-full" src="/assets/proyecto3_650.png" alt="proyecto3"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2">Noticias del mundo</div>
              <p className="text-gray-700 text-base">
                Sitio de noticias creado con WordPress, permite filtrar noticias por categoría. Demo no disponible.
              </p>
            </div>
            <div className="px-6 pt-4 pb-2">
              <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">GITHUB</button>
              <button className="inline-block bg-indigo-900 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-indigo-700 transform">VER DEMO</button>
            </div>
          </div>
        </div>
      </div>
      </div>  
      
  );
}

